import React from 'react';
interface SectionTagProps {
  icon?: string;
  children: React.ReactNode;
  tone?: 'accent' | 'primary' | 'gold';
}
const toneClasses: Record<string, string> = {
  accent: 'border-accent/30 bg-accent/10 text-accent',
  primary: 'border-primary/20 bg-primary/5 text-primary',
  gold: 'border-gold/40 bg-gold/10 text-[#9c7a4f]'
};
export function SectionTag({
  icon,
  children,
  tone = 'accent'
}: SectionTagProps) {
  return <span className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs sm:text-sm font-semibold uppercase tracking-wider ${toneClasses[tone]}`} data-id="element-261" data-mp="hisgpizxdr7">
      {icon && <span aria-hidden="true" data-id="element-262" data-mp="afynh3l5975z">{icon}</span>}
      {children}
    </span>;
}